import ApiError from "../../errors/ApiError";

export class UnlinkCustomerHostifyError extends ApiError {
  constructor() {
    super("Failed to unlink customer from Hostify");
  }
}
